module.exports = __webpack_public_path__ + "static/media/281078.3f69a18f.png";